<template>
  <div>
    <div class="row text-white inner-row" :style="object.archivedDate ? 'background: #343a40' : 'background: #00bbff'">
      <div class="col-md-10" style="text-align: left">
        <i class="tim-icons icon-minimal-up" v-on:click="changeView('toRow')" style="margin-right: 10px"></i>
        <b>{{object.name + ' (ИНН: ' + fieldView(object.inn) + ', СНИЛС: ' + fieldView(object.snils) + ')'}}</b>
      </div>
      <div class="col-md-2" style="text-align: right">
        <i v-if="!object.archivedDate" class="tim-icons icon-pencil" v-on:click="changeView('toEdit')" style="margin-right: 10px"></i>
        <b v-else-if="object.archivedDate">В АРХИВЕ</b>
      </div>
    </div>

    <simple-row :name="'Пол'" :value="object.sex === 'MALE' ? 'М' : object.sex === 'FEMALE' ? 'Ж' : 'нет данных'"></simple-row>
    <simple-row :name="'Дата рождения'" :value="convertDate(object.birthdate)"></simple-row>
    <simple-row :name="'Категория инвалидности'" :value="object.disabledCategory ? fieldView(object.disabledCategory.name) : '-'"></simple-row>
    <simple-row :name="'Паспортные данные'" :value="fieldView(object.passport)"></simple-row>
    <simple-row :name="'СНИЛС / ИНН'" :value="fieldView(object.snils) + ' / ' + fieldView(object.inn)"></simple-row>
    <div v-if="object.contact">
      <simple-row :name="'Адрес'" :value="object.contact.address"></simple-row>
      <simple-row :name="'Контактный телефон'" :value="fieldView(object.contact.phone)"></simple-row>
      <simple-row :name="'E-mail'" :value="fieldView(object.contact.email)"></simple-row>
    </div>
    <simple-row :name="'Последний звонивший'" :value="object.lastCaller"></simple-row>
    <simple-row :name="'Дата последнего звонка'" :value="convertDate(object.lastCallTime)"></simple-row>
    <simple-row :name="'Дата следующего звонка'" :value="convertDate(object.nextCallTime)"></simple-row>

    <div v-if="!hideTSRs" class="row">
      <div class="col-12">
        Список ТСР:
        <client-tsrs :client-id="object.id"></client-tsrs>
      </div>
    </div>

    <div v-if="!hideTSRs" class="row">
      <div class="col-12">
        Список договоров:
        <client-contracts :client="object"></client-contracts>
      </div>
    </div>

    <client-call-history v-if="showCalls" :item="item.object" @hide="showCalls = false" @update="update"></client-call-history>
    <p v-else> История звонков <i v-on:click="showCalls = true" class="tim-icons icon-minimal-down"></i></p>

    <client-iprs v-if="showIPRs" :item="item.object" @hide="showIPRs = false"></client-iprs>
    <p v-else> История ИПР <i v-on:click="showIPRs = true" class="tim-icons icon-minimal-down"></i></p>

    <documents v-if="showDocuments" :item="item.object" @hide="showDocuments = false"
               :parent="{type: 'CLIENT', id: object.id}"></documents>
    <p v-else> Документы <i v-on:click="showDocuments = true" class="tim-icons icon-minimal-down"></i></p>

  </div>
</template>
<script>

 import SimpleRow from "@/components/SimpleRow";
 import {longAsStringDate} from "@/services/utils";
 import ClientContracts from "@/nestedTables/ClientContracts";

 export default {
   components: {
     ClientContracts,
     SimpleRow
   },
   props:{
     item: {},
     hideTSRs: false
   },
   data() {
     return {
       tableKey: 0,
       object: this.item.object,
       showCalls: false,
       showIPRs: false,
       showDocuments: false
     }
   },
   methods: {
     convertDate(time) {
       return time ? longAsStringDate(time) : "-";
     },
     fieldView(data) {
       return data ? data : '-';
     },
     changeView(how) {
       this.$emit(how);
     },
     async update() {
       this.item.object = await this.$repo.get(this.object.id, 'client');
       this.object = this.item.object;
     }
   }
 }
</script>
<style>
</style>
